import React from "react";

const BackArrow = (props: any) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={18}
      height={18}
      fill="none"
      {...props}
    >
      <path
        fill="var(--color-blue)"
        d="M7.178 14.115a.556.556 0 0 1-.398-.165L2.228 9.397a.566.566 0 0 1 0-.795L6.78 4.05a.566.566 0 0 1 .795 0 .566.566 0 0 1 0 .795L3.42 9l4.155 4.155a.566.566 0 0 1 0 .795.544.544 0 0 1-.397.165Z"
      />
      <path
        fill="var(--color-blue)"
        d="M15.375 9.563H2.752A.567.567 0 0 1 2.19 9c0-.307.255-.563.562-.563h12.623c.307 0 .562.256.562.563a.567.567 0 0 1-.562.563Z"
      />
    </svg>
  );
};

export default BackArrow;
